import type { ValueFormatterParams } from 'ag-grid-community'

export const stringComparator = (valueA: string, valueB: string) =>
  valueA.toLocaleLowerCase().localeCompare(valueB.toLocaleLowerCase())

export const numericFormatter = (params: ValueFormatterParams) =>
  params.value ? new Intl.NumberFormat('pt-BR').format(params.value) : ''
